<template>
    <div class="wrapper-bids-lists">
        <div class="tabs">
            <div class="pb-5 wrapper-filter-button d-flex justify-content-between align-items-baseline">
                <div class="col-2 p-0" v-if="firstList && showFilter">
                    <div v-if="bids.length">
                        <button @click="show = !show" class="btn button-text filters-btn filters-btn-desktop js-open-filters">
                            Filter
                        </button>
                        <button @click="show = !show" class="btn button-text filters-btn filters-btn-mobile js-open-filters">
                            Filter
                        </button>
                    </div>
                    <div v-else class="modile-view">
                        <p class="main-text-bold text-muted">Tip: Try change filters options</p>
                        <button type="button" @click="getAllBids()"
                                class="btn-underline btn main-text filters-link text-purple px-0">
                            Clear Filters
                        </button>
                    </div>
                </div>
                <div class="ms-auto">
                    <a class="dropdown-item main-text " href="https://www.info.hedlyner.com/bid-feature">How do events work?</a>
                </div>
                <div id="slider"></div>
            </div>
            <div class="row" v-if="bids.length && show">
                <Filters :bids="bids" :url="url" :filterBudget="filterBudget"
                    :visible.sync="show" @filter="triggerFilter($event)" />
            </div>
            <br>
            <hr>
            <!--First List Search -->
            <div v-if="firstList">
                <div class="accordion accordion-flush" v-if="sortProgressBids.length" id="search-accordion-flash">
                    <AccordionItemBids
                        v-for="(bid, index) in bids" :key="index"
                        :bid="bid"
                    />
                </div>
                <div class="empty-records" v-else>
                    <h3>Your search got no hits.  Try removing some of the filters.</h3>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {notification} from "../../helpers/notification";
import axios from "axios";
import Filters from "./filters-guest.vue";
import AccordionItemBids from "./AccordionItemBids.vue";

const Swal = require('sweetalert2')

export default {
    name: "index-artist-guest",
    components: {
        Filters,
        AccordionItemBids
    },
    data() {
        return {
            url: '/events',
            bids: [],
            city_address: '',
            cloneBids: [],
            confirmedBids: [],
            bookingBids: [],
            filterBudget: {
                min: null,
                max: null,
            },
            firstList: true,
            secondList: false,
            thirdList: false,
            show: false,
            showFilter: false
        }
    },
    async mounted() {
        await this.getAllBids()
    },
    methods: {
        triggerFilter(bids) {
            this.bids = bids
        },

        async getAllBids() {
            let vm = this;
            const response = await axios.get(vm.url + '/new-and-proceed-list-guest')
                vm.filterBudget.min = response.data.min
                vm.filterBudget.max = response.data.max
                vm.bids = response.data.bids
                vm.cloneBids = response.data.bids

                if (response.data.bids.length) vm.showFilter = true
        },

        getPhoto() {
            return 'images/user/bid/';
        },

        getChildrenStatus(status) {
            let text = ''
            switch (status) {
                case 0:
                    text = 'Apply';
                    break;
                case 1:
                    text = 'Ignore';
                    break;
                case 2:
                    text = 'Ignore';
                    break;
                default:
                    text = 'Selected';
                    break;
            }
            return text
        },

        getStatus(status) {
            let text = ''
            switch (status) {
                case 0:
                    text = 'In process';
                    break;
                case 1:
                    text = 'Ready to choose';
                    break;
                case 2:
                    text = 'Wait You Approve';
                    break;
                case 3:
                    text = 'Confirmed';
                    break;
                case 4:
                    text = 'Completed';
                    break;
                case 5:
                    text = 'Canceled';
                    break;
                default:
                    text = 'Rejected';
                    break;
            }
            return text
        }
    },
    computed: {
        sortProgressBids () {
            return this.bids.sort((a, b) => new Date(a.start_date) - new Date(b.start_date))
        }
    }
}

</script>

<style lang="scss" scoped>
    @import '../../../sass/_variables.scss';
    .wrapper-keywords-pills::-webkit-scrollbar {
        display: none;
    }

    @media (max-width: 1200px) {
        .modile-view {
            min-width: 165px;
        }
    }
</style>
